/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/location';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "VerifyShippingAddressRequest": {
            "fields": {
              "shippingAddress": {
                "type": ".squareup.common.location.GlobalAddress",
                "id": 1,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "phone": {
                "type": ".squareup.common.location.Phone",
                "id": 3,
                "rule": "optional"
              },
              "save": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "VerifyShippingAddressResponse": {
            "fields": {
              "verificationStatus": {
                "type": ".squareup.solidshop.VerifyShippingAddressResponse.AddressVerificationStatus",
                "id": 1,
                "rule": "optional"
              },
              "token": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "correctedAddress": {
                "type": ".squareup.common.location.GlobalAddress",
                "id": 4,
                "rule": "optional"
              },
              "correctedField": {
                "type": ".squareup.solidshop.VerifyShippingAddressResponse.CorrectedField",
                "id": 5,
                "rule": "repeated"
              }
            },
            "nested": {
              "AddressVerificationStatus": {
                "values": {
                  "UNKNOWN_STATUS": 0,
                  "VALIDATED": 1,
                  "VALIDATED_BY_PRIMARY": 2,
                  "FAILED": 3,
                  "VALIDATION_SERVICE_ERROR": 4
                }
              },
              "CorrectedField": {
                "values": {
                  "UNKNOWN_FIELD": 0,
                  "POSTAL_CODE": 1,
                  "LOCALITY": 2,
                  "ADMINISTRATIVE_DISTRICT_LEVEL_1": 3,
                  "ADDRESS_LINE_1": 4,
                  "ADDRESS_LINE_2": 5
                }
              }
            }
          },
          "ShippingAddressVerificationService": {
            "methods": {
              "VerifyShippingAddress": {
                "requestType": ".squareup.solidshop.VerifyShippingAddressRequest",
                "responseType": ".squareup.solidshop.VerifyShippingAddressResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.VerifyShippingAddressRequest && !$root.nested?.squareup?.nested?.solidshop?.nested?.VerifyShippingAddressResponse && !$root.nested?.squareup?.nested?.solidshop?.nested?.VerifyShippingAddressResponse?.nested?.AddressVerificationStatus && !$root.nested?.squareup?.nested?.solidshop?.nested?.VerifyShippingAddressResponse?.nested?.CorrectedField && !$root.nested?.squareup?.nested?.solidshop?.nested?.ShippingAddressVerificationService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE VerifyShippingAddressRequest @ squareup/solidshop/addressVerification/service.proto at 11:1
 */
export const VerifyShippingAddressRequest = $root.lookupType('squareup.solidshop.VerifyShippingAddressRequest');
fixType(VerifyShippingAddressRequest);
Builder.createAndAttachToType(VerifyShippingAddressRequest);
/**
 * SOURCE VerifyShippingAddressResponse @ squareup/solidshop/addressVerification/service.proto at 25:1
 */
export const VerifyShippingAddressResponse = $root.lookupType('squareup.solidshop.VerifyShippingAddressResponse');
fixType(VerifyShippingAddressResponse);
Builder.createAndAttachToType(VerifyShippingAddressResponse);
/**
 * SOURCE AddressVerificationStatus @ squareup/solidshop/addressVerification/service.proto at 50:3
 */
VerifyShippingAddressResponse.AddressVerificationStatus = $root.lookupEnum('squareup.solidshop.VerifyShippingAddressResponse.AddressVerificationStatus').values;
/**
 * Which fields were corrected in the corrected address
 *
 * SOURCE CorrectedField @ squareup/solidshop/addressVerification/service.proto at 67:3
 */
VerifyShippingAddressResponse.CorrectedField = $root.lookupEnum('squareup.solidshop.VerifyShippingAddressResponse.CorrectedField').values;
/**
 * SOURCE ShippingAddressVerificationService @ squareup/solidshop/addressVerification/service.proto at 87:1
 */
export const ShippingAddressVerificationService = $root.lookupService('squareup.solidshop.ShippingAddressVerificationService');